export enum ContextEnum {
    CREATE,
    UPDATE
  }